import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DateRangeSelectionComponent, ParamDate } from '@Components/date-range-selection/date-range-selection.component';
import { SelectItemComponent } from '@Components/ui/select-item/select-item.component';
import { UIHelper } from '@Components/util/UIHelper';
import { DataEntity, ENUM_ACTIONS, PeriodState } from '@Interfaces/index';
import { AdfiGrowlService } from '@services/adfi-growl.service';
import { AdfiService } from '@services/adfi-service';
import { LoadingService } from '@services/loading.service';
import { Attribute, Column, Type } from '@Components/table/table.component';


@Component({
  selector: 'app-consumption-report',
  templateUrl: './consumption-report.component.html',
  styleUrls: ['./consumption-report.component.scss']
})
export class ConsumptionReportComponent implements OnInit {

  canSearchConsolidated: boolean;
  canSelectResponsible = false;
  selectedDates: ParamDate;
  townOrIe = '';
  parameters: { typeProducts: [], responsible: [] };
  typeProduct: Number;
  responsible: Number;
  assets: [];
  loadingAssets = true;

  columns: Column[] = [
    {
      column: 'ID_CC',
      name: 'Centro de costo',
      type: Type.String,
      attr: { classCell: 'text-center' } as Attribute
    }, {
      column: 'DE_DESCRIPCION',
      name: 'Nombre',
      type: Type.String,
      attr: {} as Attribute
    }, {
      column: 'CONSECUTIVE',
      name: 'Consecutivo',
      type: Type.String,
      attr: { classCell: 'text-center' } as Attribute
    },
    {
      column: 'ORIGIN',
      name: 'Origen',
      type: Type.String,
      attr: { classCell: 'text-center' } as Attribute
    }, {
      column: 'TYPE_PRODUCT',
      name: 'Tipo Artículo',
      type: Type.String,
      attr: { classCell: 'text-center' } as Attribute
    },
    {
      column: 'DESCRIPTION',
      name: 'Descripción del artículo',
      type: Type.String,
      attr: {} as Attribute
    },
    {
      column: 'ORIGINAL_QUANTITY',
      name: 'Cantidad Inicial',
      type: Type.Number,
      attr: { classCell: 'text-center' } as Attribute
    },
    {
      column: 'DELIVERY_DATE',
      name: 'Fecha de Entrega',
      type: Type.Date,
      attr: { classCell: 'text-center' } as Attribute
    },
    {
      column: 'OBSERVATION',
      name: 'Observación Entrega',
      type: Type.String,
      attr: {} as Attribute
    },
    {
      column: 'HEARDQUARTER',
      name: 'Sede',
      type: Type.String,
      attr: {} as Attribute
    },
    {
      column: 'LOCATION',
      name: 'Lugar',
      type: Type.String,
      attr: {} as Attribute
    },
    {
      column: 'EMPLOYEE',
      name: 'Responsable',
      type: Type.String,
      attr: {} as Attribute
    },
    {
      column: 'QUANTITY',
      name: 'Cantidad Entregada',
      type: Type.Number,
      attr: { classCell: 'text-center' } as Attribute
    },
    {
      column: 'BALANCE',
      name: 'Saldo En Bodega',
      type: Type.Number,
      attr: { classCell: 'text-center' } as Attribute
    }
  ];
  canExport = false;

  constructor(
    public service: AdfiService,
    private adfiGrowlService: AdfiGrowlService,
    public loading: LoadingService,
    private matDialog: MatDialog,

  ) { }

  ngOnInit(): void {
    this.canSearchConsolidated = this.service.validPermission('InventoryConsumptionReport', 'list', PeriodState.NO_STATUS);
    this.canExport = this.service.validPermission('BlockingPlatform', 'export', PeriodState.NO_STATUS);
    if (!this.canSearchConsolidated) {
      this.townOrIe = this.service.user.centroCosto._id;
      this.columns = this.columns.slice(2);
      this.canSelectResponsible = true;
    }
    this.loadConfigData();
  }

  loadConfigData() {
    const next = (d) => {
      if (d && d.fileName) {
        this.parameters = JSON.parse(d.fileName);
        this.loading.hide();
      } else {
        this.adfiGrowlService.error('Reporte', 'Se ha presentado un error al obtener la información, por favor contacta a soporte técnico');
        this.loading.hide();
      }
    };
    this.service.getJson(
      'GetConsumptionReportFilters',
      JSON.stringify(this.getFilters()),
      'fileName',
      next
    );
  }

  loadData() {
    this.loadingAssets = false;
    const next = (d) => {
      if (d && d.fileName) {
        this.assets = JSON.parse(d.fileName);
        this.loadingAssets = true;
        this.loading.hide();
      } else {
        this.adfiGrowlService.error('Reporte', 'Se ha presentado un error al obtener la información, por favor contacta a soporte técnico');
        this.loading.hide();
      }
    };
    this.service.getJson(
      'GetDeliveryRecord',
      JSON.stringify(this.getFilters()),
      'fileName',
      next
    );
  }

  exportTo(format: string) {
    if (!this.loading.active()) {
      this.service.download(
        'GetDeliveryRecord',
        JSON.stringify(this.getFilters()),
        'fileName',
        `application/${format}`,
        this.canSearchConsolidated ? 'Reporte de Entregas.xlsx' : 'Reporte de Entregas - ' + this.service.user.centroCosto.deDescripcion + '.xlsx',
        this.canSearchConsolidated ? '' : 'thisCenter'
      );
    }
  }

  getFilters() {
    return {
      startDate: this.selectedDates?.startDate?.toUTCString(),
      endDate: this.selectedDates?.endDate?.toUTCString(),
      townOrIe: this.townOrIe,
      consolidated: this.canSearchConsolidated,
      responsible: this.responsible,
      typeProduct: this.typeProduct
    };
  }

  selectDates() {
    this.loading.show();
    const dialog = this.matDialog.open(DateRangeSelectionComponent, {
      data: {
        startDate: this.selectedDates ? this.selectedDates.startDate : null,
        endDate: this.selectedDates ? this.selectedDates.endDate : null
      } as ParamDate
    });
    dialog.componentInstance.btnText = 'Seleccionar';
    const subs = dialog.componentInstance.afterSelect.subscribe((dates: ParamDate) => {
      subs.unsubscribe();
      this.selectedDates = dates;
      dialog.close();
    });
  }

  resetFilters() {
    this.selectedDates = null;
    if (this.canSearchConsolidated) this.townOrIe = '';
    this.typeProduct = null;
    this.responsible = null
    this.assets = null;
  }

  openCenterSearch() {
    const data = { entityName: 'PrCentroCosto', module: '', enableAdd: false } as DataEntity;
    const c = UIHelper.openDialog(SelectItemComponent, this.matDialog, data, ENUM_ACTIONS.SELECT);
    const select = (row) => {
      if (row) {
        if (!this.townOrIe || this.townOrIe.trim() === '') {
          this.townOrIe = '' + row._id;
          this.canSelectResponsible = true;
        } else {
          this.townOrIe += ',' + row._id;
          this.canSelectResponsible = false;
          this.responsible = null;
        }
      }
      subs.unsubscribe();
    };
    const subs = c.componentInstance.dialogRef.afterClosed().subscribe(select);
  }

  checkRowColor(ctx, row, table) {
    return 'without-highlight without-background budget-lvl-' + (row.BUDGET_CODE ? row.BUDGET_CODE.length : 1);
  }

}
